import React, {Component} from 'react';
import {Router, Switch, Route} from 'react-router-dom';
import history from '../history';

// @load pages
import NotFound from '../pages/NotFound';
import Home from '../pages/Home';

class RouterPages extends Component {
    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route path={"/"} exact render={(props) => {
                        return <Home {...props} />
                    }} />
                    
                    <Route path={"/*"} render={(props) => {
                        return <NotFound {...props} />
                    }} />
                </Switch>
            </Router>
        )
    }
}

export default RouterPages;